import { authenticatedApiRequest, cleanEmptyFields } from "./core";
import type { PaginatedResponse, PartyFilters } from "./core";
import type { Party, CreateParty, ContributorDetailsWithRelations } from "@/types";

export interface PaginatedPartiesResponse extends PaginatedResponse {
  results: Party[];
}

export const partiesApi = {
  getParty: async (id: string): Promise<Party> => {
    return authenticatedApiRequest<Party>(`/accounts/parties/${id}`);
  },
  getContributorDetails: async (id: string): Promise<ContributorDetailsWithRelations> => {
    return authenticatedApiRequest<ContributorDetailsWithRelations>(
      `/catalogue/contributors/${id}/details`,
    );
  },
  getParties: async (filters?: PartyFilters): Promise<PaginatedPartiesResponse> => {
    const queryFilters = filters
      ? new URLSearchParams(
          Object.entries(filters).filter(([, v]) => v != null) as [string, string][],
        ).toString()
      : "";
    return authenticatedApiRequest<PaginatedPartiesResponse>(
      `/accounts/parties${queryFilters ? `?${queryFilters}` : ""}`,
    );
  },
  createParty: async (party: CreateParty): Promise<Party> => {
    return authenticatedApiRequest<Party>("/accounts/parties", {
      method: "POST",
      body: JSON.stringify(cleanEmptyFields(party)),
    });
  },
  updateParty: async (id: string, party: Partial<CreateParty>): Promise<Party> => {
    return authenticatedApiRequest<Party>(`/accounts/parties/${id}`, {
      method: "PATCH",
      body: JSON.stringify(party),
    });
  },
  deleteParty: async (id: string): Promise<void> => {
    await authenticatedApiRequest<void>(`/accounts/parties/${id}`, {
      method: "DELETE",
    });
  },
};
